import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import WizardButtons from '../wizard/navigator/buttons';
import messages from '../../text/messages';
import { RadioField } from '../fields';
import { required } from '../../utilities/validation';
import selectOptions from '../../text/selectOptions';

class FontChoicesForm extends React.Component {
    render() {
        const { handleSubmit, cancel, submitting, name, signatureFont } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 font-options modal-font-options">
                        <Field
                            name="esig_font"
                            validate={required}
                            component={RadioField}
                            options={selectOptions.getSignatureFonts(name, signatureFont)}
                            placeholder={messages.chooseAStyle}
                        />
                    </div>
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'createSignature.disclaimer'}
                            defaultMessage={
                                'By clicking Create & Sign, I agree that the signature selected will be the electronic representation of my signature for all purposes when I (or my agent) use them in this system, including legally binding contracts - just the same as a pen-and-paper signature; and I affix my signature to the document on this page.'
                            }
                        />
                    </div>
                </div>

                <WizardButtons disabled={submitting} cancel={{ action: cancel }} submit={{ message: <FormattedMessage {...messages.createSign} /> }} />
            </form>
        );
    }
}

FontChoicesForm.defaultProps = {
    handleSubmit: undefined,
    cancel: undefined,
    name: undefined
};

FontChoicesForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func,
    name: PropTypes.string.isRequired
};

FontChoicesForm = reduxForm({
    form: 'change-signature-form',
    destroyOnUnmount: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(FontChoicesForm);

FontChoicesForm = connect(state => ({
    signatureFont: formValueSelector('change-signature-form')(state, 'esig_font')
}))(FontChoicesForm);

export default FontChoicesForm;



// WEBPACK FOOTER //
// ./src/components/signature/fontChoices.jsx